import HttpGlobal from "../Global/HttpGlobal.class";
import { customerApiBaseUrl, isNativeMode } from "../../../native/nativeMode";
import { UpdatePaymentMethodI } from "./Interfaces/PaymentMethodI.request";
import {
  AvailablePaymentMethodI,
  CardOnlyI,
  DataCardI,
} from "./Interfaces/PaymentMethodI.response";

export default class HttpPaymentRepository extends HttpGlobal {
  private readonly API_URL_PAYMENT:
    | string
    | undefined = `${process.env.REACT_APP_CUSTOMER_APP_URL}api/payment`;

  private readonly API_URL_PAYMENT_METHOD:
    | string
    | undefined = `${process.env.REACT_APP_CUSTOMER_APP_URL}api/payment-method`;

  private readonly API_URL_BESTPRICE:
    | string
    | undefined = `${process.env.REACT_APP_CUSTOMER_APP_URL}api/best-price`;

  getBestPrice = async (token: string) => {
    const response = await this.generalGet(
      `${this.API_URL_BESTPRICE}/${token}`
    );
    return response;
  };

  getDataCard = async (): Promise<DataCardI> => {
    const url = isNativeMode()
      ? `${customerApiBaseUrl()}/customer/leads/${this.leadId}/card`
      : `${this.API_URL_PAYMENT_METHOD}/get-last-four-digits/${this.leadId}`;
    const response: DataCardI = await this.generalGet(url);
    return response;
  };

  availablePaymentMethod = async (): Promise<AvailablePaymentMethodI> => {
    const response: AvailablePaymentMethodI = await this.generalPost({
      url: `${this.API_URL_PAYMENT_METHOD}/available-payment-method`,
      dataRequest: { ulid: this.leadId },
    });
    return response;
  };

  setup = async () => {
    // Organic native (F5d): register-identity + create-profile + profile-config
    // en el gateway (trío funnel native-aware). Devuelve {clientSecret, name,
    // lastName, ...} — misma forma que consume StripeContext como setupIntent.
    const url = isNativeMode()
      ? `${customerApiBaseUrl()}/customer/leads/${this.leadId}/payment/setup`
      : `${this.API_URL_PAYMENT}/setup/${this.leadId}`;
    const response = await this.generalPost({ url, dataRequest: {} });

    return response;
  };

  // Marca «solo tarjeta» de la suscripción del lead. El ULID va en el path: el
  // backend lo compara con el del token.
  getCardOnly = async (): Promise<CardOnlyI> => {
    const response: CardOnlyI = await this.generalGet(
      `${this.API_URL_PAYMENT_METHOD}/card-only/${this.leadId}`
    );
    return response;
  };

  // Native (Portal Cliente IT): página de Stripe para cambiar tarjeta/SEPA de la
  // suscripción; al terminar vuelve a Pagos y ms-payment deja el método nuevo.
  paymentMethodSetupLink = async (): Promise<string | null> => {
    const response = await this.generalPost({
      url: `${customerApiBaseUrl()}/customer/leads/${this.leadId}/payment-method/setup-link`,
      dataRequest: {},
    });
    return typeof response?.url === "string" ? response.url : null;
  };

  updatePaymentMethod = async (data: UpdatePaymentMethodI) => {
    const response = await this.generalPut({
      url: `${this.API_URL_PAYMENT_METHOD}/update-payment-method`,
      dataRequest: data,
    });

    return response;
  };
}
